<template>
    <modal
        data-testid="dialog-container"
        v-bind="attrs"
        v-on="listeners"
    >
        <template #title>
            <slot name="title">
                <h3 class="title main-text-color" data-testid="dialog-title">
                    {{ dialogTitle }}
                </h3>
            </slot>
        </template>
        <slot>
            <template>
                <div class="mt-10 mb-8 flex flex-col items-center justify-center" data-testid="dialog-message">
                    <component :is="dialogConfig.descriptionIcon" />
                    <div class="text-center main-text-color text-sm leading-21 mt-5 max-w-65-p break-normal">
                        {{ dialogDescription }}
                    </div>
                </div>
            </template>
        </slot>
        <template #footer>
            <div class="footer" data-testid="dialog-actions">
                <slot name="footer-actions">
                    <cancel-button
                        data-testid="dialog-button-cancel"
                        :icon="dialogConfig.cancelIcon"
                        :label="dialogConfig.cancelText"
                        @on-click="onCancel"
                    />
                    <confirm-button
                        data-testid="dialog-button-confirm"
                        :icon="dialogConfig.confirmIcon"
                        :label="dialogConfig.confirmText"
                        @on-click="onConfirm"
                    />
                </slot>
            </div>
        </template>
    </modal>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'

export default {
    name: 'Dialog',
    mixins: [ dialogMixin ],
    components: {
        Modal: () => import('@/components/Common/Modal.vue'),
        CancelButton: () => import('@/components/Common/Buttons/CancelButton.vue'),
        ConfirmButton: () => import('@/components/Common/Buttons/ConfirmButton.vue')
    }
}
</script>

<style lang="scss">
.title {
    @apply text-2xl font-semibold;
}
.footer {
    @apply border-t-2 border-gray-300 py-4 px-10 flex items-center justify-between;
}
</style>
